import type { Variants } from "motion/react";
import { duration, easing } from "@/lib/animation/tokens";

/**
 * Per-mark animation rules for the homepage hero title.
 *
 * The h1 itself is wrapped in a `<StaggerItem>` (so it fades up with the
 * rest of the hero text), and these variants drive the smaller text
 * accents *inside* the h1 — independent of the parent stagger so they
 * can have their own personality.
 */

/**
 * Italic mark — a small "pop" up + scale-in.
 *
 * Slight overshoot easing makes it feel handwritten / hand-drawn rather
 * than mechanical. No own delay — it inherits the parent StaggerGroup's
 * "visible" state via Motion's variant propagation, so it fires at the
 * exact moment the h1 line itself starts to reveal (i.e. it animates
 * alongside the surrounding text, not after it).
 */
export const italicPopVariants: Variants = {
  hidden: { opacity: 0, scale: 0.7, y: 12 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: duration.md,
      ease: easing.outBack,
    },
  },
};

